import * as React from "react";

import ComponentPage from "../../Components/ComponentPage";
import Usage from "../../Docs/Components/FocusGroup/FocusGroupUsage.mdx";

import Examples from "../../Docs/Components/FocusGroup/FocusGroupExamples";
        
class Page extends React.Component {
public render() {
    return (
        <ComponentPage
            name="FocusGroup"
            description="Combine multiple components into one tab stop using a focus group."
            apiSources={["azure-devops-ui/Components/FocusGroup/FocusGroup.Props.d.ts"]}
            examples={Examples}
            usage={Usage}
        />
    );
}
}
        
export default Page;